<template>
  <section>
    <div class="role">
      <div class="roleLeft" style="width:150px;cursor: pointer">
        <div :class="['roleLeft_List', 'clickTree' ]">
          <div class="top_btns">共 {{ accountnNumberList.length }} 个账户</div>
          <div class="item-son" style="margin: 10px auto">
            <el-select
                v-model="channeParams.channelType"
                placeholder="请选择渠道类型"
                clearable
                filterable
                @clear="clearInfo"
                @change="channeChang"
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in channelData"
                  :key="index"
                  :label="item.name"
                  :value="item.channelType"
              ></el-option>
            </el-select>
          </div>
          <div v-for="(item,index) in accountnNumberList" :key="index">
            <div :class="{'actiuve_txt':params.channelAccountId==item.channelAccountId}"
                 @click="channelAccount(item)" class="widcolis">
              <el-tooltip class="item" effect="dark" :content="'['+item.channelTypeName+']'+ item.name+'('+item.code+')'" placement="left-start">
                <span class="widcolis">[{{ item.channelTypeName }}] {{ item.name }}({{ item.code }})</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchAdminLsit"
          ></el-input>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchAdminLsit"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              style="width: 100%;font-size: 12px"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="50">
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>

            <el-table-column fixed prop="channelTypeName" width="181" label="创意">
              <template slot-scope="scope">
                <div class="content_infos">
                  <div class="name">{{ scope.row.title }}</div>
                  <img :src="scope.row.head">
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed label="操作" min-width="100">
              <template slot-scope="scope">
                <span v-if="editShow" style="color: #3a8ee6;margin-right:10px;cursor: pointer" @click="handleClick('edit', scope.row)">修改</span>
                <span v-if="deleteShow" style="color: #c7302f;cursor: pointer" @click="del(scope.row)">删除</span>
              </template>
            </el-table-column>
            <el-table-column prop="appName" label="创作者" min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.advertiserName }}({{ scope.row.advertiserNumber }})</span>
              </template>
            </el-table-column>
            <el-table-column prop="channelTypeName" width="80" label="渠道类型"></el-table-column>
            <el-table-column prop="fbContent" label="渠道名称" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.channelName }}({{ scope.row.channelCode }})</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="抵达" min-width="80">
              <template slot-scope="scope">0</template>
            </el-table-column>
            <el-table-column prop="" label="提测" min-width="80">
              <template slot-scope="scope">
                <div>0</div>
                <div>0.00%</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="完题" min-width="80">
              <template slot-scope="scope">
                <div>0</div>
                <div>0.00%</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="支付" min-width="80">
              <template slot-scope="scope">
                <div>0</div>
                <div>0.00%</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="成交额" min-width="80">
              <template slot-scope="scope">0.00</template>
            </el-table-column>
            <el-table-column prop="" label="客单价" min-width="80">
              <template slot-scope="scope">0.00</template>
            </el-table-column>
            <el-table-column prop="ctime" label="时间" min-width="180"></el-table-column>

          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="编辑/新建创意"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="855px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="110px"
        >
          <!-- 角色 菜单分配 -->
          <el-row>
            <el-col :span="12">
              <el-form-item v-if="clickType!='edit'" class="item" label="账户："
              >
                <el-select
                    v-model="params.channelAccountId"
                    placeholder="请选择业务类型"
                    clearable
                    filterable
                    style="width:260px"
                >
                  <el-option :key="index" :value="item.channelAccountId" v-for="(item,index) in accountnNumberList"  :label="'['+item.channelTypeName+']'+item.name+'('+item.code+')'"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="clickType!='addNext'" class="item" label="账户："
              >
               {{'['+params.channelTypeName+']-'+params.channelName+'-('+params.channelCode+')'}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="item" label="投放方式："
              > {{ params.putWayName }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="bizType" class="item" label="业务："
              >
                <el-select
                    v-model="params.bizType"
                    placeholder="请选择业务类型"
                    clearable
                    filterable
                    @change="changSelect"
                    style="width:180px"
                >
                  <el-option label="测评" value="exam"></el-option>
<!--                  <el-option label="国学" value="guoxue"></el-option>-->
<!--                  <el-option label="塔罗" value="taluo"></el-option>-->
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="item" label="计划/单元："
              >默认
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <span class="clear_icon_items" style="left: 45px;top: 12px">*</span>
              <el-form-item class="item" label="产品："
              >
                <div style="cursor: pointer">
                  <span @click="changShowTest" v-if="params.bizName">{{ params.bizName}}</span>
                  <el-tag @click="changShowTest" v-else>请选择</el-tag>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="item" label="标识："
              >{{ params.bizUid }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="创意名称：" prop="name">
                <el-input @input="onInput()" v-model="params.name" placeholder="请填写创意名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="创意标题：" prop="title">
                <el-input v-model="params.title" placeholder="请填写创意标题"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="ismore">
            <el-row>
              <el-col :span="24">
                <el-form-item label="描述第一行：">
                  <el-input type="textarea" :rows="2" v-model="params.descr" placeholder="请填写描述第一行"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="描述第二行：">
                  <el-input type="textarea" :rows="2" v-model="params.descr2" placeholder="请填写描述第二行"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <div @click="changMore" class="info_tabs">{{ ismore ? '收起内容' : '更多内容' }}
            <i :class="{'active_info':ismore==true,'active_non':ismore==false}" style="font-size: 14px;color: #959595"
               class="el-icon-arrow-right"></i>
          </div>
          <el-row>
            <el-col :span="24" style="position: relative">
              <span class="clear_icon_items">*</span>
              <el-form-item label="创意素材：" prop="">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                    <draggable class="list-group" v-model="srcListBanner" :options="{animation: 60,}"
                               :move="getdata" @update="datadragEnd">
                       <span v-for="(imgUrl, index) in srcListBanner" :key="index" class="slideshow">
                          <div class="icon-close" @click="removeUploading(index)">
                              <i class="el-icon-close"></i>
                          </div>
                          <el-image style="width: 160px; height: 100px;  border-radius: 6px"
                                    :src="imgUrl"
                                    fit="fill"
                                   />
                       </span>
                    </draggable>
                    <div
                        v-if="srcListBanner.length<=10"
                        class="up-btn"
                        style="width: 160px; height: 100px;  line-height: 120px"
                        @click="getPolicyBanner"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      multiple="multiple"
                      type="file"
                      ref="fileBanner"
                      @change="getFileBanner"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>

    <!-- 测评题数据 -->
    <el-dialog
        title="测评题列表"
        :visible.sync="alldataSourceVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div style="display: flex;align-items: center;margin-bottom: 20px">
          <div class="item-son" style="margin-right: 20px">
            <el-input
                style="width: 200px"
                v-model="listParams.searchKey"
                placeholder="搜索关键词"
                clearable
                @keyup.enter.native="queryTestTableData"
            ></el-input>
          </div>
          <div class="item-son">
            <el-button type="primary" @click="queryTestTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
        </div>
        <div class="public-table-data" style="padding-bottom: 20px">
          <el-table
              ref="multipleTableTest"
              size="medium"
              :data="allTestTableData"
              border
              highlight-current-row
              style="width: 100%"
              v-loading="loading"
              @current-change="handleTarotSelectionChange"
          >
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="examId" label="标识" width="150" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="分类" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.categoryName1 }} - {{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog
        title="提示"
        :visible.sync="showVisble"
        width="330px"
        top="30vh"
        :show-close="false"
        center>
      <div style="text-align: center">您的创意已收录，感谢上传!</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">返回列表</el-button>
        <el-button type="primary" @click="changShowVisble">继续新建</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";
import {ossUpload} from "@utils/filters/upload";
import draggable from 'vuedraggable';

export default {
  components: {
    draggable
  },
  data() {
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      pageCount: 0,
      search: {
        channelAccountId:''
      },
      dialogVisible: false, //弹出框显示隐藏
      clickType: "add", //弹窗类型
      params: {
        materials: [],
        channelAccountId: '',
        appInfoId: 0,
        bizType:'exam'
      }, //弹窗修改数据
      listParams: {},
      rules: {
        name: [
          {required: true, message: "请填写创意名称", trigger: "blur"},
        ],
        title: [
          {required: true, message: "请填写创意名称", trigger: "blur"},
        ],
        bizType: [
          {required: true, message: "请选择业务类型", trigger: "change"},
        ],
        bizUid: [
          {required: true, message: "请选择测评题"},
        ],
      }, //表单验证提示
      tableData: [], //二级--管理员列表
      accountnNumberList: [],
      channelData: [],
      addShow: false,
      deleteShow: false,
      editShow: false,
      searchShow: false,
      srcListBanner: [],
      ismore: false,
      alldataSourceVisible: false,
      allTestTableData: [],
      showVisble: false,
      channeParams: {
        permissionType: 'tf'
      },
      channeNumber:0,

      allaccountnNumberList:[]
    };
  },
  created() {
    this.getstaffList();  //获取投放专员的数据列表
    this.getPermissionButtonList()  //权限设置
    this.channelList()
    this.queryTestTableData()
    this.getChannelList() //获取当前人员已绑定的渠道账号
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {
          materials: [],
          appInfoId: 0,
          bizType:'exam',
          channelAccountId: '',
          channelTypeName: '',
          channelAccountName: '',
          putWayName: '',
          channelAccountCode: ''
        };
        this.srcListBanner = []
        this.search.channelAccountId = ''
      }
    },
    'search.channelAccountId'() {
      this.getstaffList()
    },
  },
  methods: {
    onInput(){
      this.$forceUpdate();
    },
    getdata(e){
    },
    datadragEnd(evt){
      this.params.materials[evt.oldIndex].seq = evt.newIndex
      this.params.materials[evt.newIndex].seq = evt.oldIndex
    },
    onClose() {
      this.showVisble = false
      this.dialogVisible = false
    },
    changShowVisble() {
      this.params = {
        materials: [],
        appInfoId: 0,
        channelAccountId: this.params.channelAccountId,
        channelTypeName: this.params.channelTypeName,
        channelAccountName: this.params.channelAccountName,
        putWayName: this.params.putWayName,
        channelAccountCode: this.params.channelAccountCode,
        name: this.params.name,
        title: this.params.title,
        descr: this.params.descr,
        descr2: this.params.descr2,
        bizType:this.params.bizType,
        bizName:this.params.bizName,
        bizUid:this.params.bizUid,
        bizId : this.params.bizId
      }
      this.srcListBanner = []
      this.showVisble = false

    },
    channelAccount(items) {
      if(!this.search.channelAccountId){
        this.search.channelAccountId = items.channelAccountId
        this.params.channelAccountId = items.channelAccountId
      }else {
        if(this.search.channelAccountId==items.channelAccountId){
          this.search.channelAccountId = ''
          this.params.channelAccountId = ''
        }else {
          this.search.channelAccountId = items.channelAccountId
          this.params.channelAccountId = items.channelAccountId
        }
      }
      this.params.channelTypeName = items.channelTypeName
      this.params.putWayName = items.putWayName
      this.params.channelAccountName = items.name
      this.params.channelAccountCode = items.code

    },
    changShowTest() {
      if (this.clickType == 'addNext') {
        this.alldataSourceVisible = true
      }
    },

    changSelect(){
      // if(this.params.bizType == 'guoxue'){
      //   this.params.bizName = '宝宝取名'
      //   this.params.bizId = '1'
      //   this.params.bizUid = 'BBQM001'
      // }else {
      //   this.params.bizName = ''
      //   this.params.bizId = ''
      //   this.params.bizUid = ''
      // }
    },

    handleTarotSelectionChange(e) {
      this.params.bizName = e.name
      this.params.bizId = e.examInfoId
      this.params.bizUid = e.examId
      this.alldataSourceVisible = false
    },
    changMore() {
      this.ismore = !this.ismore
    },
    //权限
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'launch:ideas:query') {
            this.searchShow = true
          }
          if (item.code == 'launch:ideas:add') {
            this.addShow = true
          }
          if (item.code == "launch:ideas:delete") {
            this.deleteShow = true
          }
          if (item.code == "launch:ideas:edit") {
            this.editShow = true
          }
        })
      }
    },
    //渠道类型列表
    async channelList() {
      const {data: resData} = await this.$get(
          "channel/type/list",
          {
            params: {
              status: 1,
              paging: false,
            },
          },
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.channelData = resData.data;
    },
    channeChang() {
      let arr= []
      this.allaccountnNumberList.map(item=>{
        if(item.channelType == this.channeParams.channelType){
          arr.push(item)
        }
      })
      this.accountnNumberList = JSON.parse(JSON.stringify(arr))
    },

    clearInfo(){
      this.accountnNumberList = JSON.parse(JSON.stringify(this.allaccountnNumberList))
    },

    //已绑定的账号
    async getChannelList() {
      this.loading = true;
      const {data: resData} = await this.$get(`/advertiser/channel/tf/list?channelType=`+this.channeParams.channelType);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;

      if(resData.data){
        this.accountnNumberList = resData.data
        this.allaccountnNumberList = resData.data
      }else {
        this.accountnNumberList = []
        this.allaccountnNumberList = []
        this.channeNumber = 0
      }
    },
    //获取所有的创意列表
    async getstaffList(node) {
      let http = `/advert/list`;
      this.loading = true;
      const {data: res} = await this.$get(
          http,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      if (res.data) {
        this.tableData = res.data;
        this.pageCount = res.page.count;
      } else {
        this.tableData = []
        this.pageCount = 0
      }
    },
    //获取测评题
    async queryTestTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/list?styleType=cpzy&paging=false",{
        params:{
          ...this.listParams
        }
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.allTestTableData = resData.data
    },
    //新增编辑专员弹窗
    async handleClick(type, row) {
      this.clickType = type;
      if (type == "edit") {
        this.loading = true;
        const {data: resData} = await this.$get("/advert/info/" + row.advertId);
        this.loading = false;
        if (resData.result != 200) return;
        this.params = resData.data
        this.params.channelAccountName = resData.data.channelName
        this.params.channelAccountCode = resData.data.channelCode
        this.params.channelAccountId = Number(resData.data.channelAccountId)
        if(resData.data.descr2 || resData.data.descr){
          this.ismore = true
        }else {
          this.ismore = false
        }
        if (resData.data.materials) {
          resData.data.materials.map(item => {
            this.srcListBanner.push(item.path)
          })
        }else {
          this.params.materials = []
          this.params.head = ''
        }
        this.dialogVisible = true
      } else {
        if (!this.params.channelAccountId) {
          // this.search.channelAccountId = this.accountnNumberList[0].channelAccountId
          this.params.putWayName = this.accountnNumberList[0].putWayName
          this.params.channelAccountId = this.accountnNumberList[0].channelAccountId
          this.params.channelTypeName = this.accountnNumberList[0].channelTypeName
          this.params.channelAccountName = this.accountnNumberList[0].name
          this.params.channelAccountCode = this.accountnNumberList.code
        }
        this.ismore = false
        this.params.name = this.changDefaultName()
        this.params.materials = []
        this.params.head = ''
        this.dialogVisible = true
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.params.head = this.srcListBanner[0]
        if (this.srcListBanner.length <= 0) {
          this.$message.error('请上传创意素材')
          return;
        }
        if (!this.params.bizUid) {
          this.$message.error('请选择测评产品')
          return;
        }
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/advert/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getstaffList();
            this.showVisble = true
            this.$message.success("添加成功!");
          } else {
            const {data: resData} = await this.$put(
                "/advert/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getstaffList();
            this.dialogVisible = false
            this.$message.success("修改成功!");
          }
        });
      });
    },
    changDefaultName(){
      let str = ''
      let date = new Date()
      let yearsStr =  date.getFullYear().toString()
      let year = yearsStr.substring(yearsStr.length - 2)
      let mouth =  date.getMonth()+1
      if(mouth<=9){
        mouth = '0'+mouth
      }
      let day =  date.getDate()
      if(day<=9){
        day = '0'+day
      }
      let hours =  date.getHours()
      if(hours<=9){
        hours = '0'+hours
      }
      let minutes =  date.getMinutes()
      if(minutes<=9){
        minutes = '0'+minutes
      }
      str = 'ttcy_'+year+'_'+mouth+'_'+day+'_'+hours+':'+minutes
      return str
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/advert/info/${row.advertId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getstaffList();
        this.$message.success("删除成功!");
      });
    },
    //图片上传
    getPolicyBanner() {
      this.$refs.fileBanner.dispatchEvent(new MouseEvent("click"));
    },

    async getFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      let onFile = that.$refs.fileBanner.files
      for(let i = 0;i<onFile.length;i++){
        const addRoutes = await ossUpload(
            onFile[i],
            resData.data,
            "more", //'more','one'
            this.srcListBanner,
            'ideas_name'
        );
        this.isMoerBanner = false;
        this.srcListBanner = addRoutes;
        let obj = {
          hpx: 0,
          wpx: 0,
          name: onFile[i].name,
          path: this.srcListBanner[this.srcListBanner.length - 1],
          suffix: onFile[i].type,
          seq:this.srcListBanner.length>0?i+this.srcListBanner.length:i
        }
        this.params.materials.push(obj)
      }
    },

    removeUploading(index) {
      this.srcListBanner.splice(index, 1);
      this.params.materials.splice(index, 1)
      // this.form.payIntro = this.srcListBanner;
    },
    //查询专员
    SearchAdminLsit() {
      this.page.pageNo = 1
      this.getstaffList()
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getstaffList();
    },

    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getstaffList();
    },
  },
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: 14px;
  top: 14px;
}

.role {
  display: flex;
  // gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  &Right {
    flex: 1;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.dialog-tree {
  max-height: 420px;
  overflow-y: auto;
}

.role .el-button--small, .el-button--small.is-round {
  padding: 5px 10px !important;
}

.channel_items {
  display: flex;
  margin-bottom: 15px;

  .titles {
    width: 80px;
    text-align: right;
  }
}

.table_cou {
  height: auto;
  width: calc(100% - 80px);

  .tab_header_th {
    height: 30px;
    border: 1px solid rgba(231, 231, 231, 1);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-left: 1px solid rgba(231, 231, 231, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .qutuns {
      width: 100px;
    }

    .names {
      width: 80px;
    }

    .name_box_auto {
      width: 220px;
    }

    .code_box {
      width: 100px;
    }

    .post_inof {
      width: 80px;
    }

    .inde_auto {
      width: 50px;
    }

    .comtemts {
      width: 120px;
    }
  }

  .tab_body_content {
    .tab_content_td {
      display: flex;
      border: 1px solid rgba(231, 231, 231, 1);
      border-top: none;
      box-sizing: border-box;
      min-height: 30px;
      border-bottom: none;
    }

    .right_contents {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 80px);

      .right_items {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 30px;
        border-bottom: 1px solid rgba(231, 231, 231, 1);

        div {
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-left: 1px solid rgba(231, 231, 231, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .account_index {
          width: 50px;
        }
      }

      .account_box {
        width: 200px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
      }

      .contun_box_c {
        width: 100px;
        border-left: 1px solid rgba(231, 231, 231, 1);

        .box_icons {
          padding: 5px 10px;
          font-size: 12px;
          color: #ffffff;
          background-color: #3a8ee6;
          border-radius: 4px;
        }

        .active_none {
          background-color: rgba(0, 0, 0, 0.1);
          color: #606266;
        }
      }

      .account_name {
        width: 100px;
        padding: 0 10px;
      }

      .account_code {
        width: 100px;
      }

      .account_putWay {
        width: 80px;
      }

      .account_des {
        width: 100px;
      }
    }

    .left_contents {
      width: 80px;
      border-bottom: 1px solid rgba(231, 231, 231, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.items {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .left_name {
    width: 120px;
    text-align: right;

  }
}

.info_tab_tas {
  display: flex;
  align-items: center;
}

.roleLeft_List{
  gap: 0;
}

.widcolis {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
  font-size: 12px;
}

.top_btns {
  background: rgba(242, 242, 242, 1);
  height: 31px;
  line-height: 31px;
  padding: 0 10px;
  border-radius: 4px;
}

.content_infos {
  .name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align: left;
  }

  img {
    height: 100px;
    width: 100%;
  }
}


.info_tabs {
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  transform: rotate(0deg);
  color: #999999;
}

.actiuve_txt {
  color: #3a8ee6;
}

.info_tabs i {
  margin-left: 5px;
}

.active_info {
  transform: rotate(-90deg);
  transition: all 0.3s linear;
}

.active_non {
  transform: rotate(90deg);
  transition: all 0.3s linear;
}

.puciusdasd2q .el-dialog__header {
  border: 0 !important;
}
.screenshot{
  display: flex;
  align-items: flex-start;
}
.list-group{
  max-width: calc(100% - 180px);
}
</style>

<style>
.channel_items .el-tabs__nav-wrap {
  width: 270px !important;
}

.channel_items .el-tabs__nav {
  width: 100% !important;
}

.channel_items .el-tabs__item {
  width: 50%;
  padding: 0 !important;
  text-align: center;
  font-weight: 600;
}

.channel_items .el-tabs__active-bar {
  height: 1px !important;
}

.channel_items .el-tabs__nav-wrap::after {
  height: 1px !important;
}

/*.content .el-tabs__nav-scroll{*/
/*  width: 270px !important;*/
/*}*/
</style>